export enum TypeBook {
  LivrosDidatico,
  InfantoJuvenil,
}
